import { useMemo } from "react";
import PropTypes from "prop-types";

const FrameComponent4 = ({
  className = "",
  groupDivPadding,
  tiCKVNgViIuKh,
  tiCWidth,
  tiCDisplay,
  onClickContinue, // 👈 thêm props sự kiện
}) => {
  const groupDivStyle = useMemo(() => {
    return {
      padding: groupDivPadding,
    };
  }, [groupDivPadding]);

  const tiCStyle = useMemo(() => {
    return {
      width: tiCWidth,
      display: tiCDisplay,
    };
  }, [tiCWidth, tiCDisplay]);

  return (
    <div
      className={`flex flex-row items-start justify-start py-0 px-10 box-border max-w-full text-center text-base text-light-primary-key-background font-text-regular-lowercase ${className}`}
    >
      <div
        onClick={onClickContinue} // 👈 thêm xử lý bấm nút
        className="rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] flex flex-row items-start justify-start py-5 px-[27px] box-border max-w-full"
        style={groupDivStyle}
      >
        <div className="h-[60px] w-[360px] relative rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] hidden max-w-full" />
        <div
          className="w-[306px] relative font-medium inline-block z-[1]"
          style={tiCStyle}
        >
          {tiCKVNgViIuKh}
        </div>
      </div>
    </div>
  );
};

FrameComponent4.propTypes = {
  className: PropTypes.string,
  tiCKVNgViIuKh: PropTypes.string,

  /** Style props */
  groupDivPadding: PropTypes.string,
  tiCWidth: PropTypes.string,
  tiCDisplay: PropTypes.string,
  onClickContinue: PropTypes.func, // 👈 thêm dòng này
};

export default FrameComponent4;
